<script type="text/ecmascript-6">
    import DesignerQuestionHardwareSecurityChain from "../DesignerQuestionHardwareSecurityChain.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareSecurityChain,
            SynsealTileQuestion,
        ],
    }
</script>
